import { Link } from "react-router-dom";
import { SUPPORT_EMAIL } from "@/config/contact";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border/60 bg-background mt-16">
      <div className="container py-10 grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo.png" alt="Vecurate" className="w-8 h-8 object-contain" />
            <span className="font-serif text-lg text-foreground">vecurate</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs">
            Real reviews from real students on rotations, residencies, fellowships and internships.
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-3">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/rotations" className="text-foreground hover:text-primary transition-colors">Rotations</Link></li>
            <li><Link to="/residencies" className="text-foreground hover:text-primary transition-colors">Residencies</Link></li>
            <li><Link to="/fellowships" className="text-foreground hover:text-primary transition-colors">Fellowships</Link></li>
            <li><Link to="/internships" className="text-foreground hover:text-primary transition-colors">Internships</Link></li>
            <li><Link to="/search" className="text-foreground hover:text-primary transition-colors">Search</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-3">Legal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="text-foreground hover:text-primary transition-colors">Contact us</Link></li>
            <li><Link to="/terms" className="text-foreground hover:text-primary transition-colors">Terms of Service</Link></li>
            <li><Link to="/privacy" className="text-foreground hover:text-primary transition-colors">Privacy Policy</Link></li>
            <li><Link to="/content-policy" className="text-foreground hover:text-primary transition-colors">Content Policy</Link></li>
            <li><Link to="/community-guidelines" className="text-foreground hover:text-primary transition-colors">Community Guidelines</Link></li>
            <li><Link to="/dmca" className="text-foreground hover:text-primary transition-colors">DMCA / Copyright</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border/60">
        <div className="container py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <p>© {year} Vecurate. All rights reserved.</p>
          <p>
            Questions? <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary hover:underline">{SUPPORT_EMAIL}</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
